/* eslint-disable @typescript-eslint/no-unused-vars */
import useMediaQuery from "@mui/material/useMediaQuery";
import crownV2 from "assets/crownV2.png";
import { useDIPAction } from "components/DIP/hooks";
import { useDIPRewardsV2 } from "components/DIP/hooks/useDIPRewardsV2";
import { useAppSelector } from "hooks";
import { Fragment } from "react";
import { selectDipState } from "redux/slices";
import { sortBundleRewards } from "helpers/rewardSort";
import { CrownIcon } from "utils/svgIcons";
import { getFlexBasis } from "../helper";
import {
	Container,
	CrossOutValue,
	CustomButtom,
	DataContainer,
	InfoContainer,
	ItemImage,
	Items,
	LoyaltyContainer,
	LoyaltyPoints,
	OfferItem,
	RewardAmount,
	RewardItem,
	SubTitle
} from "./styles";

interface OffersProps {}

export const CountdownOffer: React.FC<OffersProps> = () => {
	const { currentDip, claimRewardProcess } = useAppSelector(selectDipState);
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging, including Bouncy Chest offers.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const { onAction } = useDIPAction();
	const { loading } = claimRewardProcess;
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const isMobile = isPortrait;

	const {
		price,
		buyType,
		buttonLabel,
		rewards,
		loyaltyPointReward,
		loyaltyPointCrossout
	} = useDIPRewardsV2(currentDip?.buttons?.[0]);

	if (!currentDip) {
		return null;
	}

	const data = currentDip.buttons ?? [];
	const { dip } = currentDip;
	const bouncyChestClass =
		dip.triggerType === "bouncyChestClick" ? "bouncy-chest" : "";

	return (
		<Container>
			<DataContainer>
				{data?.map((item) => {
					return (
						<Fragment key={item.id}>
							<OfferItem>
								<Items>
									{sortBundleRewards(rewards).map(
										({ imageUrl, description, id }, key) => {
											const flexBasis = getFlexBasis(
												data,
												rewards,
												isMobile,
												bouncyChestClass
											);

											return (
												<RewardItem key={key} width={flexBasis + "%"}>
													<ItemImage src={imageUrl} alt="" />
													<RewardAmount>{description}</RewardAmount>
												</RewardItem>
											);
										}
									)}

									{/* {arrayTest.map(({}, key) => {
										const flexBasis = getFlexBasis(
											data,
											rewards,
											isMobile,
											bouncyChestClass
										);
										return (
											<RewardItem key={key} width={flexBasis + "%"}>
												<ItemImage
													src={
														"https://cdn.solitairetripeaks.com/WebStore/reward_images/coin.png"
													}https://cdn-a1.tripeaksapp.com
													alt=""
												/>
												<RewardAmount>{200}</RewardAmount>
											</RewardItem>
										);
									})} */}
								</Items>
							</OfferItem>
							<SubTitle>
								{buyType !== "loyalty_points" && "You also get:"}
							</SubTitle>
							<LoyaltyContainer>
								<ItemImage className="crown" src={crownV2} />
								<InfoContainer>
									{loyaltyPointCrossout && (
										<CrossOutValue>
											{loyaltyPointCrossout?.toLocaleString("en-US")}
										</CrossOutValue>
									)}
									<LoyaltyPoints>
										{loyaltyPointReward?.toLocaleString("en-US")} Loyalty Points
									</LoyaltyPoints>
									{/*
										{isPoisActive && (
											<PoisBounty>Contribute to Poi’s Bounty</PoisBounty>
										)}
									*/}
								</InfoContainer>
								{/* <InfoButton
									src={infoIcon}
									//onClick={() => openInfoPopup()}
								></InfoButton> */}
							</LoyaltyContainer>
							<CustomButtom
								variant="contained"
								color="success"
								size="large"
								disabled={loading}
								onClick={() => onAction(item, price)}
							>
								{!buttonLabel ? (
									<Fragment>
										{buyType === "loyalty_points" && (
											<CrownIcon width={"1em"} height={"1em"} />
										)}
										{price}
										{buyType === "usd" && " USD"}
									</Fragment>
								) : (
									buttonLabel
								)}
							</CustomButtom>
						</Fragment>
					);
				})}
			</DataContainer>
		</Container>
	);
};
